import PropTypes from 'prop-types';

import { LESSON_TYPES } from '@classCreation/data/lessonTypes';

const LessonResourceType = PropTypes.shape({
  test_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  test_group_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lesson_type: PropTypes.oneOf(Object.values(LESSON_TYPES)),
  duration: PropTypes.number,
});

export default LessonResourceType;
